// Find components upward
function findComponentUpward (context, componentName, componentNames) {
  componentNames = typeof componentName === 'string' ? [componentName] : componentName

  let parent = context.$parent
  let name = parent.$options.name
  while (parent && (!name || componentNames.indexOf(name) < 0)) {
    parent = parent.$parent
    if (parent) name = parent.$options.name
  }

  return parent
}

export {findComponentUpward}

export default {
  /**
   * 获取 dom 的样式属性
   * @param {Element} element   用于获取计算样式的 Element
   * @param {String}  styleName 元素的样式名
   */
  getStyle (element, styleName) {
    return window.getComputedStyle(element).getPropertyValue(styleName)
  },
  /**
   * 获取 dom 的相对位置
   * @param {Element} $reference    用于获取计算样式的 Element
   * @param {Boolean} useScrollLeft 是否包含滚动条的宽度
   * @param {Boolean} useScrollTop  是否包含滚动条的高度
   */
  offset ($reference, useScrollTop, useScrollLeft) {
    const offset = $reference.getBoundingClientRect()
    const scrollLeft = useScrollLeft ? (window.pageXOffset || document.documentElement.scrollLeft) : 0
    const scrollTop = useScrollTop ? (window.pageYOffset || document.documentElement.scrollTop) : 0

    return {
      left: offset.left + scrollLeft,
      right: offset.right,
      top: offset.top + scrollTop,
      bottom: offset.bottom,
      width: offset.width,
      height: offset.height
    }
  },
  /**
   * 根据参照物获取 dom 的绝对位置
   * @param {Element} $reference     参照 dom
   * @param {Element} $popper        气泡 dom
   * @param {Object}  options        配置项
   * @param {Boolean} options.useScrollTop   是否包含滚动条的高度
   * @param {Object}  options.offset         dom 的位置包含[left,top,right,bottom,width,height]
   * @param {String}  options.position       气泡的相对位置
   * @param {Number}  options.left           气泡左边的偏移增量
   * @param {Number}  options.top            气泡上边的偏移增量
   * @param {Boolean} options.isInner        气泡是否处于内联相对位置
   */
  position ($reference, $popper, options = {}) {
    const {position, isInner} = options
    const offset = isInner ? {
      width: $reference.offsetWidth,
      height: $reference.offsetHeight
    } : this.offset($reference, options.useScrollTop, options.useScrollLeft)

    const width = $popper.offsetWidth
    const height = $popper.offsetHeight
    let left = (offset.left | 0) + (options.left | 0)
    let top = (offset.top | 0) + (options.top | 0)

    switch (position) {
      case 'top':
        top -= height
        left += offset.width / 2 - width / 2
        break
      case 'top-start':
        top -= height
        break
      case 'top-end':
        top -= height
        left += offset.width - width
        break
      case 'bottom':
        top += offset.height
        left += offset.width / 2 - width / 2
        break
      case 'bottom-start':
        top += offset.height
        break
      case 'bottom-end':
        top += offset.height
        left += offset.width - width
        break
      case 'left':
        top += offset.height / 2 - height / 2
        left -= width
        break
      case 'left-start':
        left -= width
        break
      case 'left-end':
        top += offset.height - height
        left -= width
        break
      case 'right':
        top += offset.height / 2 - height / 2
        left += offset.width
        break
      case 'right-start':
        left += offset.width
        break
      case 'right-end':
        top += offset.height - height
        left += offset.width
        break
      default:
    }

    return {
      left,
      top,
      width,
      height
    }
  },
  visibleListener (dom, cb, option) {
    let observer = false

    if (window.IntersectionObserver) {
      observer = true
    }

    if (observer) {
      return new IntersectionObserver(cb, option)
    } else {
      return {
        observe (target) {},
        unobserve (target) {},
        disconnect () {}
      }
    }
  }
}
